module.exports = __webpack_public_path__ + "static/media/GroupChatImage.b1a1d429.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/GroupChatImage.png
// module id = 925
// module chunks = 0